import * as React from 'react'
import { useMemo } from 'react'

import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import type { ConditionModel } from '@user/components/Settings/LeadAssignmentRule/LeadAssignmentRuleForm/typings'
import { useTranslation } from 'react-i18next'

type Props = {
  condition: ConditionModel
}

export function LeadAssignmentConditionInfo(props: Props) {
  const { t } = useTranslation()
  const { condition } = props
  const { attribute } = condition
  const values = useMemo(() => {
    const names = condition.assignmentRuleConditionValues.map(
      (value: any) =>
        `${
          value?.name ||
          value?.label ||
          value?.fullName ||
          value?.value ||
          value
        }${value?.abbreviation ? ` (${value?.abbreviation})` : ''}${
          value?.description ? ` - ${value?.description}` : ''
        }`,
    )
    return ` ${names.join(', ')}`
  }, [condition.assignmentRuleConditionValues])

  const title = useMemo(() => {
    switch (attribute) {
      case 'ZipCode':
        return t('postalCode')
      case 'Branch':
        return 'Branch'
      case 'Campaign':
        return 'Campaign'
      case 'LeadSource':
        return 'Lead Source'
      case 'State':
        return 'State'
      case 'LocationType':
        return 'Location Type'
      case 'Division':
        return 'Division'
      case 'CreatedBy':
        return 'Created By'
      case 'TargetPest':
        return 'Target Pests'
      case 'LeadType':
        return 'Type'
      case 'Territory':
        return 'Territory'
      default:
        return ''
    }
  }, [attribute])

  return (
    <Stack>
      <Typography variant="subtitle2">{title}</Typography>
      <Typography variant="body2">
        <Typography variant="subtitle2" component="span">
          {condition.matchType}:
        </Typography>{' '}
        {values}
      </Typography>
    </Stack>
  )
}
